import { render, staticRenderFns } from "./Mycolle.vue?vue&type=template&id=1400686d&scoped=true"
import script from "./Mycolle.vue?vue&type=script&lang=js"
export * from "./Mycolle.vue?vue&type=script&lang=js"
import style0 from "./Mycolle.vue?vue&type=style&index=0&id=1400686d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1400686d",
  null
  
)

export default component.exports